'use client';

import { useEffect, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export const THEME_KEY = 'ks-theme';

export default function ThemeToggle() {
	const { t } = useLanguage();
	const [dark, setDark] = useState(false);

	useEffect(() => {
		setDark(document.documentElement.getAttribute('data-theme') === 'dark');
	}, []);

	const toggle = () => {
		const next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
		document.documentElement.setAttribute('data-theme', next);
		try {
			localStorage.setItem(THEME_KEY, next);
		} catch {
			/* stockage indisponible : le choix vaut pour la session */
		}
		setDark(next === 'dark');
	};

	return (
		<button type="button" className="icon-btn theme" aria-pressed={dark} aria-label={dark ? t.nav.themeToLight : t.nav.themeToDark} onClick={toggle}>
			<svg className="sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
			<svg className="moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" /></svg>
		</button>
	);
}
